import { createI18n } from 'vue-i18n'
import enUS from 'vant/es/locale/lang/en-US'
import hiIN from 'vant/es/locale/lang/hi-IN' // 添加印地语
import ptBR from 'vant/es/locale/lang/pt-BR' // 添加葡萄牙语
import { Locale } from 'vant'
import type { PickerColumn } from 'vant'

const FALLBACK_LOCALE = 'en-US' // 改为葡萄牙语作为默认语言

const vantLocales = {
  'en-US': enUS,
  'hi-IN': hiIN, // 添加印地语
  'pt-BR': ptBR, // 添加葡萄牙语
}

export const languageColumns: PickerColumn = [
  // { text: 'Português', value: 'pt-BR', }, // 葡萄牙语选项
  { text: 'English', value: 'en-US', icon: getAssetsFile('home/enFlag.png') },
  // { text: 'हिंदी', value: 'hi-IN',icon: getAssetsFile('home/hiFlag.png') }, // 添加印地语选项
]

export const i18n = setupI18n()
type I18n = typeof i18n

export const locale = computed({
  get() {
    return i18n.global.locale.value
  },
  set(language: string) {
    setLang(language, i18n)
  },
})

function setupI18n() {
  const locale = getI18nLocale()
  const i18n = createI18n({
    locale,
    legacy: false,
  })
  setLang(locale, i18n)
  return i18n
}

async function setLang(lang: string, i18n: I18n) {
  await loadLocaleMsg(lang, i18n)

  document.querySelector('html').setAttribute('lang', lang)
  localStorage.setItem('language', lang)
  i18n.global.locale.value = lang

  // 设置 vant 组件语言包
  Locale.use(lang, vantLocales[lang])

  // 清除可能受语言影响的缓存
  // 这里可以添加清除活动列表等缓存的逻辑
}

// 加载本地语言包
async function loadLocaleMsg(locale: string, i18n: I18n) {
  const messages = await import(`../locales/${locale}.json`)
  i18n.global.setLocaleMessage(locale, messages.default)
}

// 获取当前语言对应的语言包名称
function getI18nLocale() {
  // 获取浏览器语言
  const browserLanguage = navigator.language || navigator.languages?.[0] || 'en-US'
  console.log('浏览器语言:', browserLanguage)
  
  // 优先使用用户手动选择的语言（但如果浏览器语言变化了，也考虑更新）
  const storedLocale = localStorage.getItem('language')
  
  // 如果 localStorage 中有值，但浏览器语言是菲律宾语且存储的不是菲律宾语，则使用浏览器语言
  // 这样可以确保当用户切换浏览器语言时，项目也能自动切换
  if (storedLocale) {
    // 检查浏览器语言是否是菲律宾语
    const filipinoLanguageCodes = ['tl', 'fil', 'tl-PH', 'fil-PH']
    const browserLangCode = browserLanguage.split('-')[0].toLowerCase()
    const isFilipino = filipinoLanguageCodes.some(code => 
      browserLanguage.toLowerCase() === code.toLowerCase() || 
      browserLangCode === code.toLowerCase()
    )
    
    // 如果浏览器是菲律宾语，但存储的不是，则使用浏览器语言
    if (isFilipino && storedLocale !== 'tl-PH') {
      console.log('检测到浏览器语言是菲律宾语，但存储的不是，使用浏览器语言')
      return 'tl-PH'
    }
    
    return storedLocale
  }

  // 支持的语言列表
  const supportedLanguages = ['en-US', 'pt-BR', 'hi-IN', 'tl-PH']

  // 菲律宾语的语言代码映射（浏览器可能使用 'tl', 'fil', 'tl-PH' 等）
  const filipinoLanguageCodes = ['tl', 'fil', 'tl-PH', 'fil-PH']

  // 检查是否是菲律宾语
  const browserLangCode = browserLanguage.split('-')[0].toLowerCase()
  const isFilipino = filipinoLanguageCodes.some(code => 
    browserLanguage.toLowerCase() === code.toLowerCase() || 
    browserLangCode === code.toLowerCase()
  )

  if (isFilipino) {
    console.log('检测到菲律宾语，使用 tl-PH')
    return 'tl-PH'
  }

  // 检查浏览器语言是否匹配支持的语言
  // 处理语言代码匹配（如 'pt' 匹配 'pt-BR', 'en' 匹配 'en-US', 'hi' 匹配 'hi-IN'）
  const matchedLanguage = supportedLanguages.find(lang => {
    const langCode = lang.split('-')[0].toLowerCase() // 提取主要语言代码
    const browserLangCode = browserLanguage.split('-')[0].toLowerCase()
    return langCode === browserLangCode || lang.toLowerCase() === browserLanguage.toLowerCase()
  })

  console.log('匹配的语言:', matchedLanguage || FALLBACK_LOCALE)

  // 如果找到匹配的语言，使用该语言；否则使用默认语言
  return matchedLanguage || FALLBACK_LOCALE
}
